/**
 * @generated SignedSource<<44676e88351503ec74d9733ae15d6987>>
 * @relayHash bfc43724fd2fc3a6f132a6d5f7e9da68
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID aebc4ac6f19efb4f09e20cf9c09e3afa223b9374353fd6d698d7b653144dd21f

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceForgeAttachmentActionLocation = "ACTION" | "METADATA" | "%future added value";
export type ConfluenceForgeAttachmentActionSurface = "ATTACHMENT_MACRO" | "ATTACHMENT_PAGE" | "%future added value";
export type ConfluenceForgeContextTokenRequestInput = {
  contextIds: ReadonlyArray<string | null>;
  extensionSpecificContexts: ConfluenceExtensionSpecificContext;
};
export type ConfluenceExtensionSpecificContext = {
  appVersion: string;
  context: ConfluenceForgePayloadContext;
  extensionId: string;
  extensionType?: string | null;
  installationId?: string | null;
};
export type ConfluenceForgePayloadContext = {
  appVersion?: string | null;
  config?: string | null;
  content?: ConfluenceForgeExtensionDataContent | null;
  contentId?: string | null;
  environmentId?: string | null;
  environmentType?: string | null;
  extension: ConfluenceForgeExtensionData;
  isConfig?: boolean | null;
  localId?: string | null;
  macro?: ConfluenceForgeExtensionDataMacro | null;
  moduleKey?: string | null;
  siteUrl?: string | null;
  space?: ConfluenceForgeExtensionDataSpace | null;
  spaceKey?: string | null;
  type?: string | null;
};
export type ConfluenceForgeExtensionDataContent = {
  id: string;
  status?: string | null;
  subtype?: string | null;
  type?: string | null;
  version?: number | null;
};
export type ConfluenceForgeExtensionData = {
  attachment?: ConfluenceForgeExtensionDataAttachment | null;
  attachmentActionLocation?: ConfluenceForgeAttachmentActionLocation | null;
  attachmentActionSurface?: ConfluenceForgeAttachmentActionSurface | null;
  autoConvertLink?: string | null;
  config?: string | null;
  content?: ConfluenceForgeExtensionDataContent | null;
  isConfig?: boolean | null;
  isEditing?: boolean | null;
  location?: string | null;
  macro?: ConfluenceForgeExtensionDataMacro | null;
  references?: ReadonlyArray<string | null> | null;
  selectedText?: string | null;
  space?: ConfluenceForgeExtensionDataSpace | null;
  template?: ConfluenceForgeExtensionDataTemplate | null;
  type: string;
};
export type ConfluenceForgeExtensionDataAttachment = {
  id: string;
};
export type ConfluenceForgeExtensionDataMacro = {
  body?: string | null;
  isConfiguring?: boolean | null;
  isInserting?: boolean | null;
  layout?: string | null;
};
export type ConfluenceForgeExtensionDataSpace = {
  id?: string | null;
  key?: string | null;
};
export type ConfluenceForgeExtensionDataTemplate = {
  id?: string | null;
};
export type useGetContextTokenMutation$variables = {
  cloudId: string;
  input: ConfluenceForgeContextTokenRequestInput;
};
export type useGetContextTokenMutation$data = {
  readonly confluence_generateForgeContextToken: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }> | null;
    readonly forgeContextToken: {
      readonly expiresAt: string | null;
      readonly extensionId: string | null;
      readonly jwt: string | null;
    } | null;
    readonly success: boolean;
  } | null;
};
export type useGetContextTokenMutation = {
  response: useGetContextTokenMutation$data;
  variables: useGetContextTokenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfluenceForgeContextTokenPayload",
    "kind": "LinkedField",
    "name": "confluence_generateForgeContextToken",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      },
      {
        "concreteType": "ConfluenceForgeContextToken",
        "kind": "LinkedField",
        "name": "forgeContextToken",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "jwt"
          },
          {
            "kind": "ScalarField",
            "name": "expiresAt"
          },
          {
            "kind": "ScalarField",
            "name": "extensionId"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useGetContextTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useGetContextTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bfc43724fd2fc3a6f132a6d5f7e9da68",
    "id": "aebc4ac6f19efb4f09e20cf9c09e3afa223b9374353fd6d698d7b653144dd21f",
    "metadata": {},
    "name": "useGetContextTokenMutation",
    "operationKind": "mutation",
    "text": "mutation useGetContextTokenMutation($cloudId:ID!,$input:ConfluenceForgeContextTokenRequestInput!){confluence_generateForgeContextToken(cloudId:$cloudId,input:$input){success,errors{message},forgeContextToken{jwt,expiresAt,extensionId}}}"
  }
};
})();

(node as any).hash = "881cc660c7be5fb9164424934214d110";

export default node;
